import React from "react";
import { Outlet, NavLink, Navigate, useLocation } from "react-router-dom";
import { getCustomerToken } from "../../api/client";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Seo from "../../Components/Seo/Seo";
import { useSiteSeo } from "../../context/SiteSeoContext";
import { usePrerenderReady } from "../../utils/prerenderReady";
import "./AccountLayout.css";

export default function AccountLayout() {
  const token = getCustomerToken();
  const location = useLocation();
  const siteCtx = useSiteSeo();
  usePrerenderReady(Boolean(token));

  const titleSuffix =
    siteCtx.organization_name && String(siteCtx.organization_name).trim()
      ? ` | ${String(siteCtx.organization_name).trim()}`
      : " | Gem Fashion Studios";

  if (!token) {
    return <Navigate to={`/loginSignUp?redirect=${encodeURIComponent(location.pathname || "/account")}`} replace />;
  }

  return (
    <>
      <Seo
        title={`My account${titleSuffix}`}
        description="Your orders, profile, and saved payment methods."
        canonicalPath={location.pathname}
        noindex
      />
      <Box className="account-layout">
        <aside className="account-sidebar">
          <Typography variant="h6" className="account-sidebar-title">
            My Account
          </Typography>
          <nav className="account-nav">
            <NavLink to="/account" end className={({ isActive }) => (isActive ? "active" : "")}>
              Dashboard
            </NavLink>
            <NavLink to="/account/profile" className={({ isActive }) => (isActive ? "active" : "")}>
              Profile
            </NavLink>
            <NavLink to="/account/orders" className={({ isActive }) => (isActive ? "active" : "")}>
              Orders
            </NavLink>
            <NavLink to="/account/payment-methods" className={({ isActive }) => (isActive ? "active" : "")}>
              Saved cards
            </NavLink>
          </nav>
        </aside>
        <main className="account-main">
          <Outlet />
        </main>
      </Box>
    </>
  );
}
